"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateLanguage = exports.languageSchema = void 0;
var zod = _interopRequireWildcard(require("zod"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// Even though this is `locale`, we call it `language` to be consistent with ASMS.
const languageSchema = exports.languageSchema = zod.string().regex(/^[a-z]{2}-[A-Z]{2}$/);

/**
 * Validates the provided language against the language schema.
 *
 * @param language - The language string to be validated - should be string in form of "ab-CD".
 * @returns The validated language data if the validation is successful, otherwise `undefined`.
 */
const validateLanguage = language => {
  const result = languageSchema.safeParse(language);
  if (result.success) {
    return result.data;
  }
  return undefined;
};
exports.validateLanguage = validateLanguage;
//# sourceMappingURL=validateLanguage.js.map